var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.219,
    height: 122.974,
    viewBox: "0 0 127.219 122.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6a4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f79340"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(-582.9 -583.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M641.916,677.933c5.92-.124,14.594,4.61,19.443,4.091a22.9,22.9,0,0,0,3.333-2.328s1.309-3.319,1.032-4.646a7.364,7.364,0,0,0-.889-2.348c-.313-.509-.819-1.147-1.478-1.161a.635.635,0,0,1,.145.284,3.184,3.184,0,0,1-.71,3.254,3.963,3.963,0,0,1-2.125.936c-2.442.358-4.879-.674-7.2-1.29-2.638-.708-5.307-1.443-7.977-2.082a9.549,9.549,0,0,0-2.548-.4,4.752,4.752,0,0,0-2.912,1.141c-.962.82-1.575,2.277-.672,3.374A3.652,3.652,0,0,0,641.916,677.933Z",
    fill: "#449bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M707.131,676.4a4.505,4.505,0,0,0-1.953-2.351c-.062-.018-.115-.036-.168-.053a1.015,1.015,0,0,0-.177-.045,24.724,24.724,0,0,0-5.276-.309c-.071,0-.142.009-.221.009a5.514,5.514,0,0,1,1.529,1.741c.566,1.246-.133,2.519-3.429,3.836-1.865.751-4.127,1.714-6.549,2.784-.716.318-1.441.645-2.174.972-8.405,3.782-17.782,8.3-18.966,8.908-2.793,1.441-6.036,2.59-19.284,1.644-12.488-.884-22.289-1.785-27.336-.919-.824.14-1.944.376-3.213.665-.66.441-1.341.836-2.031,1.22a2.414,2.414,0,0,1,.117.376,5.806,5.806,0,0,1,.911.609c.742.5,1.429,1.043,2.149,1.57a27.629,27.629,0,0,0,3.757,2.231c.121-.02.244-.037.37-.052.494-.053,1.016-.1,1.582-.123,1.714-.1,3.747-.089,6.054-.009.751.035,1.537.062,2.35.106.433.026.875.044,1.326.071q1.272.066,2.625.159c1.379.1,2.828.194,4.339.3.99.071,2.006.142,3.04.221,1.565.115,3.191.239,4.861.354,9.006.636,13.39.318,16.147-.407.141-.035.274-.071.407-.115.291-.088.565-.176.83-.274.133-.044.265-.1.389-.15.327-.133.628-.265.919-.406.2-.1.4-.2.592-.292.354-.177,25.984-12.886,34.768-17.243.08-.044.168-.088.239-.132a3.33,3.33,0,0,0,.442-.3A3.8,3.8,0,0,0,707.131,676.4Z",
    fill: "#449bc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M659.923,701.69c-2.261,0-5.008-.107-8.4-.347q-2.161-.155-4.21-.308c-10.189-.751-18.236-1.344-22.655-.671l-.244-1.605c4.6-.7,12.728-.1,23.018.657q2.046.15,4.206.308c12.906.912,16.174-.165,18.852-1.555.169-.1,6.165-3.072,18.842-9.354,6.212-3.079,12.425-6.157,15.939-7.9,1.447-.717,2.587-2.7,1.89-4.176a3.442,3.442,0,0,0-2.245-1.755c-7.46-1.314-16.367,1.569-24.981,4.358-9.01,2.916-17.521,5.671-23.424,3.153l.568-1.519a6.38,6.38,0,0,0,7.8-3.373,4.931,4.931,0,0,0-.089-3.984,5.509,5.509,0,0,0-3.37-2.906c-21.517-7-28.118-8.784-33.558-8.028-.144.02-14.825,2.45-26.354,17.368l-1.285-.993c11.922-15.427,27.263-17.962,27.415-17.983,6.044-.84,13.764,1.42,34.283,8.092a7.207,7.207,0,0,1,4.342,3.766,6.54,6.54,0,0,1,.118,5.286,7.454,7.454,0,0,1-3.239,3.6c4.711-.28,10.39-2.118,16.29-4.027,8.8-2.85,17.906-5.8,25.755-4.414a5.028,5.028,0,0,1,3.439,2.664c1.131,2.4-.482,5.256-2.636,6.323-3.514,1.746-9.728,4.825-15.94,7.9-9.058,4.489-18.424,9.13-18.795,9.33C669,700.77,666.558,701.69,659.923,701.69Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M656.572,682.515a154.587,154.587,0,0,0-15.42-3.916l.339-1.588a156.268,156.268,0,0,1,15.594,3.963Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.953
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M626.7,705.827l-1.2-1.093,1.689-1.857-31.33-26.485-10.609,12.756L584,688.11,595.656,674.1l33.866,28.629Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M619.962,702.96a3.086,3.086,0,1,1-3.086-3.086A3.087,3.087,0,0,1,619.962,702.96Z",
    fill: "#449bc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M650.547,597.28c7.495-11.992,29.878-8.994,35.873,7.494,6.873,18.9-8.892,38.973-35.873,52.463-26.98-13.49-42.847-33.563-35.974-52.463C620.569,588.286,643.053,585.288,650.547,597.28Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M646.552,655.269a2.034,2.034,0,0,1-.909-.215c-29.733-14.867-43.9-35.931-36.975-54.974a24.577,24.577,0,0,1,20.786-15.99c6.871-.714,13.148,1.483,17.1,5.838,3.941-4.355,10.213-6.562,17.043-5.84a24.546,24.546,0,0,1,20.739,15.992,28.336,28.336,0,0,1,1.687,11.269,2.032,2.032,0,1,1-4.057-.223,24.255,24.255,0,0,0-1.448-9.658,20.572,20.572,0,0,0-17.345-13.34c-6.472-.678-12.035,1.648-14.9,6.228a2.032,2.032,0,0,1-3.446,0c-2.821-4.514-8.557-6.9-14.949-6.226a20.6,20.6,0,0,0-17.393,13.338c-6.095,16.758,6.946,35.665,34.065,49.494,17.443-8.9,29.4-20.2,33.717-31.886a2.031,2.031,0,0,1,3.811,1.407c-4.753,12.863-17.758,25.141-36.62,34.571A2.033,2.033,0,0,1,646.552,655.269Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M649.612,634.352a2.049,2.049,0,0,1-1.88-1.261L635.8,603.925l-8.418,14.431a2.033,2.033,0,0,1-1.495.99,2.009,2.009,0,0,1-1.7-.577l-6.133-6.132-13.555,12.2a2.032,2.032,0,1,1-2.719-3.02l14.989-13.491a2.033,2.033,0,0,1,2.795.074l5.632,5.632,9.165-15.712a2.012,2.012,0,0,1,1.9-1A2.032,2.032,0,0,1,638,598.575l11.733,28.682,8.529-18.279a2.032,2.032,0,0,1,3.466-.36l3.886,5.184,24.27.058a1.957,1.957,0,0,1,2,1.973,2.032,2.032,0,0,1-2.031,2.031H664.6a2.033,2.033,0,0,1-1.625-.812l-2.464-3.286-9.059,19.415A2.033,2.033,0,0,1,649.612,634.352Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeActive);
export default __webpack_public_path__ + "static/media/life-active.1658953176efefc8f7cd0116671e88f6.svg";
export { ForwardRef as ReactComponent };